module.exports = __webpack_public_path__ + "img/bookshelf_icon.2e3a5451.svg";